module.exports = {
  SEARCH: '/mocks/content-api/sitesearch/{indexSuffix}.json?query={query}&meta=breadcrumbs&filters={filters}&offset={offset}'
}
